import React from "react";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

interface OffcanvasProps {
    isActive: boolean;
    onClose: () => void;
    disableBackdropClick?: boolean,
    headerRightComponent?: React.ReactNode,
    description?: string
}

const inOffcanvas = <P extends object>(WrappedComponent: React.ComponentType<P>, title: string, description?: string) => {
    const MilestoneOffcanvas: React.FC<P & OffcanvasProps> = ({
        isActive,
        disableBackdropClick = false,
        onClose,
        headerRightComponent,
        ...props
    }) => {

        const onBackDropClick = () => {
            if (disableBackdropClick) return;
            onClose();
        }

        return (
            <Offcanvas isOpen={isActive} toggle={onClose} direction='end' id="milestone-offcanvas">
                <OffcanvasHeader className="border-bottom">
                    <h4 className="m-0">{title}</h4>
                    {description && <p className="text-muted fw-normal fs-12 m-0">{description}</p>}
                </OffcanvasHeader>
                <OffcanvasBody>
                    {
                        isActive &&
                        <WrappedComponent isActive={isActive} {...(props as P)} onClose={onClose} />
                    }
                </OffcanvasBody>
            </Offcanvas>
        );
    };

    return MilestoneOffcanvas;
};

export default inOffcanvas;